const actions = {
  SET_STATE: 'CountdownTimerHome/SET_STATE',
  CHANGE_ENTITY_VALUE: 'CountdownTimerHome/CHANGE_ENTITY_VALUE',
  RENDER_FUND_INFO: 'CountdownTimerHome/RENDER_FUND_INFO',
}

export default actions